import { Injector, NgModule, runInInjectionContext } from '@angular/core';
import { CORE_BACKEND, CoreBackendIDs } from '@bepatient/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TimelineApiApolloService } from './timeline-api.apollo.service';
import { TimelineApiMobiService } from './timeline-api.mobi.service';
import { TimelineApiService } from './timeline-api.service';
import { TimelineApiSmartService } from './timeline-api.smart.service';
import { TimelineEffects } from './timeline.effects';
import { timelineInitialState, timelineReducer } from './timeline.reducer';

// The concrete API implementations use `inject()`, so they must be constructed
// within an injection context; `runInInjectionContext` supplies the factory's
// injector so their `inject()` calls resolve exactly as before.
export const createApiService = (injector: Injector) => {
  switch (injector.get(CORE_BACKEND)) {
    case CoreBackendIDs.SMART:
      return runInInjectionContext(
        injector,
        () => new TimelineApiSmartService()
      );
    case CoreBackendIDs.APOLLO:
      return runInInjectionContext(
        injector,
        () => new TimelineApiApolloService()
      );

    default:
      return runInInjectionContext(
        injector,
        () => new TimelineApiMobiService()
      );
  }
};

@NgModule({
  imports: [
    StoreModule.forFeature('timeline', timelineReducer, {
      initialState: timelineInitialState
    }),
    EffectsModule.forFeature([TimelineEffects])
  ],
  providers: [
    {
      provide: TimelineApiService,
      useFactory: createApiService,
      deps: [Injector]
    }
  ]
})
export class TimelineStoreModule {}
